export default [
  {
    path: '/systemSetting/specialAccount',
    name: 'specialAccount',
    meta: {
      title: '特殊账号配置'
    },
    component(resolve) {
      require(['COMPONENTS/systemSetting/specialAccount/main.vue'], resolve)
    }
  },
  {
    path: '/systemSetting/initialContent',
    name: 'initialContent',
    meta: {
      title: '初始内容配置'
    },
    component(resolve) {
      require(['COMPONENTS/systemSetting/initialContent/main.vue'], resolve)
    }
  },
  {
    path: '/systemSetting/operatingRecord',
    name: 'operatingRecord',
    meta: {
      title: '操作记录'
    },
    component(resolve) {
      require(['COMPONENTS/systemSetting/operatingRecord/main.vue'], resolve)
    }
  },
  {
    path: '/systemSetting/category',
    name: 'category',
    meta: {
      title: '识别类目'
    },
    component(resolve) {
      require(['COMPONENTS/systemSetting/category/main.vue'], resolve)
    }
  },
  {
    path: '/systemSetting/categoryEdit',
    name: 'categoryEdit',
    meta: {
      title: '编辑类目'
    },
    component(resolve) {
      require(['COMPONENTS/systemSetting/category/edit.vue'], resolve)
    }
  },
]